import IcAskStanley from '@/assets/icons/ic-ask-stanley.svg';
import { GenerateBroadcastEmailForm } from './GenerateBroadcastEmailForm';

type Props = {
    onComplete: () => void;
};

export const GenerateEmailTemplateWithStanley = ({ onComplete }: Props) => {
    return (
        <div className='flex flex-col items-center gap-6 md:gap-10'>
            <div className='flex flex-col items-center gap-3 md:gap-6'>
                <IcAskStanley className='block size-10' />

                <div className='text-center'>
                    <div className='mx-auto mb-1.5 flex w-fit items-center gap-2 md:mb-3'>
                        <h3>Let Stanley Take the First Pass</h3>
                        <div className='bg-brand-main grid h-fit place-items-center rounded-sm px-1.5 py-0.5'>
                            <span className='text-body-xs text-on-brand font-bold'>Beta</span>
                        </div>
                    </div>
                    <p className='text-body-sm text-gray font-medium'>
                        Describe your email and Stanley will draft it for you.
                    </p>
                </div>
            </div>

            <GenerateBroadcastEmailForm onComplete={onComplete} />
        </div>
    );
};
